const prefix = "admin/division/list";

export const FETCH_DIVISION_LIST = `${prefix}/FETCH_DIVISION_LIST`;
export const FETCH_DIVISION_LIST_START = `${prefix}/FETCH_DIVISION_LIST_START`;
export const FETCH_DIVISION_LIST_SUCCESS = `${prefix}/FETCH_DIVISION_LIST_SUCCESS`;
export const FETCH_DIVISION_LIST_FAIL = `${prefix}/FETCH_DIVISION_LIST_FAIL`;

export const ADD_DIVISION = `${prefix}/ADD_DIVISION`;
export const ADD_DIVISION_START = `${prefix}/ADD_DIVISION_START`;
export const ADD_DIVISION_SUCCESS = `${prefix}/ADD_DIVISION_SUCCESS`;
export const ADD_DIVISION_FAIL = `${prefix}/ADD_DIVISION_FAIL`;

export const UPDATE_DIVISION = `${prefix}/UPDATE_DIVISION`;
export const UPDATE_DIVISION_START = `${prefix}/UPDATE_DIVISION_START`;
export const UPDATE_DIVISION_SUCCESS = `${prefix}/UPDATE_DIVISION_SUCCESS`;
export const UPDATE_DIVISION_FAIL = `${prefix}/UPDATE_DIVISION_FAIL`;

export const DELETE_DIVISION = `${prefix}/DELETE_DIVISION`;
export const DELETE_DIVISION_START = `${prefix}/DELETE_DIVISION_START`;
export const DELETE_DIVISION_SUCCESS = `${prefix}/DELETE_DIVISION_SUCCESS`;
export const DELETE_DIVISION_FAIL = `${prefix}/DELETE_DIVISION`;

export const fetchDivisionList = () => ({
  type: FETCH_DIVISION_LIST,
  meta: {
    thunk: true,
  },
});

export const addDivision = (record) => ({
  type: ADD_DIVISION,
  payload: record,
  meta: {
    thunk: true,
  },
});

export const updateDivision = (record) => ({
  type: UPDATE_DIVISION,
  payload: record,
  meta: {
    thunk: true,
  },
});

export const deleteDivision = (record) => ({
  type: DELETE_DIVISION,
  payload: record,
  meta: {
    thunk: true,
  },
});
